const SERVICE_PAGE_SECTION_COMPONENT = "Service Page Section";

/**
 * @typedef {{ label: string, anchorId: string }} ServicePageNavItem
 */

/**
 * @param {string} value
 */
export function toAnchorId(value) {
    return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

/**
 * @param {any} block
 */
function isVisibleServicePageSection(block) {
    return (
        block?.component?.name === SERVICE_PAGE_SECTION_COMPONENT &&
        block?.component?.options?.hideBlock !== true
    );
}

/**
 * Extract in-page navigation items from Builder blocks.
 *
 * @param {any[] | undefined | null} blocks
 * @returns {ServicePageNavItem[]}
 */
export function getServicePageNavItems(blocks) {
    if (!Array.isArray(blocks)) {
        return [];
    }

    return blocks
        .filter(isVisibleServicePageSection)
        .map((block) => {
            const options = block.component.options ?? {};
            const label = String(options.navLabel || options.heading || "").trim();
            const anchorId = toAnchorId(options.anchorId || label);

            if (!label || !anchorId) {
                return null;
            }

            return {
                label,
                anchorId,
            };
        })
        .filter((item) => item !== null);
}
